import React, { Component } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top: !window.scrollY,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
  }

  scrollHandler = () => {
    this.setState({ top: window.pageYOffset <= 10 });
  };

  render() {
    const { top } = this.state;

    return (
      <nav style={{ marginTop: '-30px' }} className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out mb-16 ${!top ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="flex flex-row justify-between items-center py-2">
          <div className="flex flex-row justify-center md:px-12 md:mx-12 items-center text-center font-semibold">
            <HashLink smooth to="/#hero">
              <img
                src={`${process.env.PUBLIC_URL}/logoWhite.png`}
                alt="Company Logo"
                style={{ width: '150px', height: 'auto', marginLeft: '30px' }}
              />
            </HashLink>
          </div>
          <div className="hidden space-x-6 lg:inline-block p-5">
            <NavLinks />
          </div>
        </div>
      </nav>
    );
  }
}

export default NavBar;
